import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import { DeliveryTypeEnum, ShowableCartSourceModeEnum } from 'ReactApp/Types/enum';
import InputMask from "react-input-mask";
import PaymentRadioListV1 from '../PaymentRadioListV1/PaymentRadioListV1';
import CartSubmitButtonV1 from '../CartSubmitButtonV1/CartSubmitButtonV1';
import {biMarketingEventRunnerRun} from "../../../app/frontend/assets/js/services/bi/WithBiMarketingEventRunner";
import {MarketingEventTypeEnum} from "../../../app/frontend/assets/js/enums/MarketingEventTypeEnum";
import {
    MarketingEventVariableItemTypeEnum,
    MarketingEventVariableTypeEnum
} from "../../../app/frontend/assets/js/enums/MarketingEventVariableTypeEnum";
import {CurrencyTypeEnum} from "../../../app/frontend/assets/js/enums/CurrencyTypeEnum";


type CartFormV1Props = {
    showableCart: ShowableCart
}

const CartFormV1 = observer((props: CartFormV1Props) => {

    const hasStartedCheckout = React.useRef(false);

    // вызывается при начале чекауа
    const startedCheckoutHandler = () => {
        biMarketingEventRunnerRun({
            eventTypeId: MarketingEventTypeEnum.beginCheckout,
            dynamicData: {
                [MarketingEventVariableTypeEnum.items]: props.showableCart.getCardsForMarketingEventsFormat(),
                [MarketingEventVariableTypeEnum.currency]: CurrencyTypeEnum.RUB,
                [MarketingEventVariableTypeEnum.value]: props.showableCart.totalBaseSum,
                [MarketingEventVariableTypeEnum.revenue]: props.showableCart.totalBaseSum,
            }
        });
    }

    // вызывается при начале вводе адресса
    const finishedEnterDeliveryAddressHandler = () => {
        biMarketingEventRunnerRun({
            eventTypeId: MarketingEventTypeEnum.addShippingInfo,
            dynamicData: {
                 [MarketingEventVariableTypeEnum.currency]: props.showableCart.getCardsForMarketingEventsFormat(),
                 [MarketingEventVariableTypeEnum.value]: props.showableCart.totalBaseSum,
                 [MarketingEventVariableTypeEnum.items]: props.showableCart.getCardsForMarketingEventsFormat(),
                 [MarketingEventVariableTypeEnum.shippingTier]: props.showableCart.order.deliveryType,
            }
        });
    }

    const handleBeginCheckoutOnce = () => {
        if (!hasStartedCheckout.current) {
            hasStartedCheckout.current = true;
            startedCheckoutHandler();
        }
    };

    const isValidDeliveryAddress = (address: string) => {
         // Простейшая проверка: не менее 10 символов
         //&& trimmed.includes(',') можно улучшить например
        // и например содержит как минимум запятую && trimmed.includes(',') пока уберу
        // проверку уточнить у Руслана.
        return address.length >= 10;
    }

    const deliveryAddressBlurHandler = () => {
        const trimmedAddress = deliveryAddress.trim();

        if(!isValidDeliveryAddress(trimmedAddress))
            return;

        if (lastValidAddressRef.current !== trimmedAddress) {
            lastValidAddressRef.current = trimmedAddress;
            finishedEnterDeliveryAddressHandler();
        }
    }

    // добавляем стейт
    const [deliveryAddress, setDeliveryAddress] = useState(
        props.showableCart.order.deliveryAddress || ''
    );

     // реф для последнего валидного адреса
    const lastValidAddressRef = React.useRef<string | null>(null);


    const [sdekPickupPointAddress, setSdekPickupPointAddress] = useState(
        props.showableCart.order.sdekPickupPoint.address
    );
    const [sdekPickupPointId, setSdekPickupPointId] = useState(
        props.showableCart.order.sdekPickupPoint.id
    );
    const [sdekPickupPointData, setSdekPickupPointData] = useState(
        props.showableCart.order.sdekPickupPoint.data
    );

    const sdekPickupPointAddressHandler = (e) => {
        props.showableCart.order.sdekPickupPoint.address = e.currentTarget.value || null;
        setSdekPickupPointAddress(e.currentTarget.value || null);
    }
    const sdekPickupPointIdHandler = (e) => {
        props.showableCart.order.sdekPickupPoint.id = e.currentTarget.value || null;
        setSdekPickupPointId(e.currentTarget.value || null);
    }
    const sdekPickupPointDataHandler = (e) => {
        props.showableCart.order.sdekPickupPoint.data = e.currentTarget.value || null;
        setSdekPickupPointData(e.currentTarget.value || null);
    }
    const clientNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleBeginCheckoutOnce();
        props.showableCart.order.clientInfo.name = e.currentTarget.value || null;
    }
    const phoneHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleBeginCheckoutOnce();
        props.showableCart.order.clientInfo.phone = e.currentTarget.value || null;
    }
    const emailHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleBeginCheckoutOnce();
        props.showableCart.order.clientInfo.email = e.currentTarget.value || null;
    }
    const commentHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        handleBeginCheckoutOnce();
        props.showableCart.order.comment = e.currentTarget.value || null;
    }
    const deliveryTypeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.showableCart.order.deliveryType = parseInt(e.currentTarget.value) || null;
    }

    const deliveryAddressHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleBeginCheckoutOnce();
        const address = e.currentTarget.value || '';
        setDeliveryAddress(address);
        props.showableCart.order.deliveryAddress = address;
    }

    const now = new Date();

    const renderSubmitButtonPart = () => {

        if (
            props.showableCart.isOrderBeingProcessed === true
                ||
            props.showableCart.isWaitingNewVersionOrder === true
        ) {
            return (<></>);
        }
 
        return (
            <div className="action-group-v1">
                <CartSubmitButtonV1 {...{
                    href: '#',
                    label: (
                        props.showableCart.sourceMode === ShowableCartSourceModeEnum.preOrder
                            ? 'Оформить заказ'
                            : 'Изменить данные'
                    ),
                    classes: [
                        'button-v1_text-color-type-white',
                        'button-v1_filling-color-type-main',
                        'button-v1_filling-type-contained',
                    ]
                }} />
            </div>
        );
    }

    return (
        <>
            <div 
                className="
                    header-v1
                    cart-page-v1__form-title
                    header-v1_lvl-type-2
                "
                >
                    <div className="header-v1__text">оформление заказа</div>
            </div>

            <form action="/cart" method="POST">                            
                <div className="cart-form-v1">

                    <div className="cart-form-v1__step-one">
                        <div className="cart-form-v1__step-title">
                            {
                                props.showableCart.sourceMode === ShowableCartSourceModeEnum.preOrder
                                    &&
                                (<>Шаг 1: <strong>Заполните данные</strong></>)
                            }
                            {
                                props.showableCart.sourceMode === ShowableCartSourceModeEnum.order
                                    &&
                                (<><strong>Вы можете изменить персональные данные</strong></>)
                            }
                        </div>
                        <div className="cart-form-v1__one-input-row">
                            <div className="input-text-v1" data-instance-id="input-text-v1-1121362093475967649dbc023a5fe" id="input-text-v1-1121362093475967649dbc023a5fe">
                                <label className="input-text-v1__label" htmlFor="input-text-v1-1121362093475967649dbc023a5fe">Получатель</label>
                                <div className="form-group field-cartv1form-clientname">
                                    <input 
                                        type="text" 
                                        id="cartv1form-clientname" 
                                        className="input-text-v1__input" 
                                        name="CartV1Form[clientName]" 
                                        placeholder="ФИО"
                                        onChange={clientNameHandler}
                                    />
                                    <div className="help-block"></div>
                                    <div className="invalid-feedback"></div>
                                </div>
                            </div>
                        </div>

                        <div className="cart-form-v1__two-input-row">
                            <div className="input-text-v1" data-instance-id="input-text-v1-1121362093625583649dbc023a693" id="input-text-v1-1121362093625583649dbc023a693">
                                <div className="form-group field-cartv1form-clientphone">
                                    <InputMask 
                                        mask="+7 (999) 999-99-99"
                                        maskChar={'_'}
                                        onChange={phoneHandler}
                                        type="text"
                                        id="cartv1form-clientphone"
                                        className="input-text-v1__input"
                                        placeholder="Телефон*"
                                        name="CartV1Form[clientPhone]"
                                        value={props.showableCart.order.clientInfo.phone || ''}
                                    />
                                    <div className="help-block"></div>
                                    <div className="invalid-feedback"></div>
                                </div>
                            </div>
                            <div className="input-text-v1" data-instance-id="input-text-v1-1121362093696574649dbc023a6da" id="input-text-v1-1121362093696574649dbc023a6da">
                                <div className="form-group field-cartv1form-clientemail">
                                    <input 
                                        type="text" 
                                        id="cartv1form-clientemail" 
                                        className="input-text-v1__input" 
                                        name="CartV1Form[clientEmail]" 
                                        placeholder="E-mail"
                                        onChange={emailHandler}
                                    />
                                    <div className="help-block"></div>
                                    <div className="invalid-feedback"></div>
                                </div>
                            </div>        
                        </div>

                        <div className="cart-form-v1__one-input-row">
                            <div className="textarea-v1" data-instance-id="textarea-v1-1121362093770684649dbc023a724" id="textarea-v1-1121362093770684649dbc023a724">
                                <div className="form-group field-cartv1form-clientcomment">
                                    <textarea 
                                        id="cartv1form-clientcomment" 
                                        className="textarea-v1__input" 
                                        name="CartV1Form[clientComment]"
                                        placeholder="Комментарий"
                                        onChange={commentHandler}
                                        ></textarea>
                                    <div className="help-block"></div>
                                    <div className="invalid-feedback"></div>
                                </div>
                            </div>        
                        </div>

                    </div>

                    <div className="cart-form-v1__step-two">

                        <div 
                            className="
                                cart-form-v1__delivery-type-block
                                box-v1
                                box-v1_filling-type-contained
                                box-v1_filling-color-type-gray
                            "
                            >
                            <div className="cart-form-v1__step-title">
                                {
                                    props.showableCart.sourceMode === ShowableCartSourceModeEnum.preOrder
                                        &&
                                    (<>Шаг 2: <strong>Выберите способ доставки</strong></>)
                                }
                                {
                                    props.showableCart.sourceMode === ShowableCartSourceModeEnum.order
                                        &&
                                    (<><strong>Вы можете выбрать другой способ доставки</strong></>)
                                }
                            </div>
                            <div className="cart-form-v1__radio-column">
                                <div className="input-radio-list-v1" data-instance-id="input-radio-list-v1-1121362093847361649dbc023a771" id="input-radio-list-v1-1121362093847361649dbc023a771">
                            
                                    <div className="input-radio-v1" data-instance-id="input-radio-v1-1121362093877989649dbc023a78f" id="input-radio-v1-1121362093877989649dbc023a78f">
                                        <div className="form-group field-cartv1form-deliverytype">
                                            <label>
                                                <input 
                                                    type="radio" 
                                                    id="cartv1form-deliverytype" 
                                                    className="input-radio-v1__input" 
                                                    name="CartV1Form[deliveryType]" 
                                                    checked={(props.showableCart.order.deliveryType === DeliveryTypeEnum.carrier) ? true : false}
                                                    value={DeliveryTypeEnum.carrier}
                                                    onChange={deliveryTypeHandler}
                                                /> 
                                                <span className="input-radio-v1__radio-label-icon">    
                                                    <svg className="icon-v1" width="19" height="19">
                                                        <use xlinkHref="/build/sprite.svg#post-icon"></use>
                                                    </svg>    
                                                </span>
                                                <span className="input-radio-v1__radio-label">Курьер</span>
                                            </label>
                                            <div className="help-block"></div>
                                        </div>
                                    </div>

                                    <div 
                                        className={(
                                            `input-radio-v1 `
                                                + 
                                            (!props.showableCart.isSdekAvailable
                                                ? 'input-radio-v1_disabled' : '')
                                        )}
                                        data-instance-id="input-radio-v1-1121362094006942649dbc023a810" id="input-radio-v1-1121362094006942649dbc023a810">
                                        <div className="form-group field-cartv1form-deliverytype">
                                            <label>
                                                <input 
                                                    type="radio" 
                                                    id="cartv1form-deliverytype"
                                                    className="input-radio-v1__input"
                                                    name="CartV1Form[deliveryType]"
                                                    disabled={(
                                                        !(props.showableCart.isSdekAvailable)
                                                    )}
                                                    checked={(props.showableCart.order.deliveryType === DeliveryTypeEnum.pickupFromSdek) ? true : false}
                                                    value={DeliveryTypeEnum.pickupFromSdek}
                                                    onChange={deliveryTypeHandler}
                                                /> 
                                                <span className="input-radio-v1__radio-label-icon">
                                                    <svg className="icon-v1" width="19" height="19">
                                                        <use xlinkHref="/build/sprite.svg#pickup-icon"></use>
                                                    </svg>
                                                </span>
                                                <span className="input-radio-v1__radio-label">Самовывоз (СДЭК)</span>
                                            </label>
                                            <div className="help-block"></div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {props.showableCart.order.deliveryType === DeliveryTypeEnum.pickupFromSdek && (
                                <>
                                    <div className="cart-form-v1__pickup-finder-row">
                                        <input 
                                            type="hidden" 
                                            className="js-cart-pvz-address"
                                            onInput={sdekPickupPointAddressHandler}
                                            value={sdekPickupPointAddress as string} 
                                        />
                                        <input 
                                            type="hidden" 
                                            className="js-cart-pvz-id"
                                            onInput={sdekPickupPointIdHandler} 
                                            value={sdekPickupPointId as string} 
                                        />
                                        <input 
                                            type="hidden" 
                                            className="js-cart-pvz-data"
                                            onInput={sdekPickupPointDataHandler} 
                                            value={sdekPickupPointData as string} 
                                        />
                                        <a 
                                            className="
                                                button-v1
                                                cart-form-v1__pickup-finder-row-button
                                                button-v1_text-color-type-white
                                                button-v1_filling-color-type-main
                                                button-v1_filling-type-contained
                                                js-open-popup js-open-sdek-modal
                                            "
                                            href="#"
                                            data-popup="js-sdek-popup"
                                            >
                                            Найти пункт самовывоза
                                        </a>
                                        <div className="cart-form-v1__pickup-finder-row-desc">
                                            <strong>{sdekPickupPointAddress}</strong>
                                        </div>
                                        <div className="cart-form-v1__pickup-finder-row-desc">
                                            Доставка в один из пунктов самовывоза СДЭК. 
                                            Обратите внимание, СДЭК оплачивается отдельно.
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        {props.showableCart.order.deliveryType === DeliveryTypeEnum.carrier && (
                            <>
                                <div className="input-text-v1" data-instance-id="input-text-v1-1121362094170906649dbc023a8b4" id="input-text-v1-1121362094170906649dbc023a8b4">
                                    <label className="input-text-v1__label" htmlFor="input-text-v1-1121362094170906649dbc023a8b4">
                                        Адрес доставки:
                                    </label>
                                    <div className="form-group field-cartv1form-address">
                                        <input 
                                            type="text" 
                                            id="cartv1form-address" 
                                            className="input-text-v1__input" 
                                            name="CartV1Form[address]" 
                                            placeholder="Город, улица, дом, этаж, квартира"
                                            onChange={deliveryAddressHandler}
                                            onBlur={deliveryAddressBlurHandler}
                                            value={deliveryAddress}
                                        />
                                        <div className="help-block"></div>
                                        <div className="invalid-feedback"></div>
                                    </div>
                                </div>
                            </>
                        )}

                    </div>

                    <div className="cart-form-v1__step-three">
                        <div className="cart-form-v1__step-title">
                            {
                                props.showableCart.sourceMode === ShowableCartSourceModeEnum.preOrder
                                    &&
                                (<>Шаг 3: <strong>Выберите способ оплаты</strong></>)
                            }
                            {
                                props.showableCart.sourceMode === ShowableCartSourceModeEnum.order
                                    &&
                                (<><strong>Вы можете выбрать другой способ оплаты</strong></>)
                            }
                        </div>

                        <div className="cart-form-v1__radio-row">
                            <PaymentRadioListV1 {...{
                                showableCart: props.showableCart,
                                inputName: 'CartV1Form[paymentType]',
                            }} />
                        </div>
                    </div>

                    {renderSubmitButtonPart()}

                </div>
            </form>

            {/* <div className="text-v1">
                <h4>Важно</h4>
                <ul>
                    <li>После отправки заказа наши менеджеры свяжутся с вами в течение часа (с 9:00 до 22:00 ч (мск)), проверят заказ и согласуют доставку.</li>
                    <li>На все выбранные вами товары распространяется фирменная гарантия.</li>
                    <li>Обмен и возврат возможен в течении 7 дней в полном соответствии с законом.</li>
                </ul>
            </div> */}

        </>
    );

})

export default CartFormV1;